import React, { useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import AuthService from '../../services/AuthService';
import GeneralSettingsService from '../../services/GeneralSettingsService';
import CreateForm from './CreateForm';
import EditForm from './EditForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DynamicForm = () => {
    const [userName, setUserName] = useState('');
    const [showAddButton, setShowAddButton] = useState(true);
    const [initialData, setInitialData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const currentUser = AuthService.getCurrentUser();
        if (currentUser) {
            setUserName(currentUser.username);
        }

        fetchParameters();
    }, []);

    const fetchParameters = async () => {
        setIsLoading(true);
        try {
            const response = await GeneralSettingsService.getAllParameters();
            if (response.length > 0) {
                const firstParameter = response[0];
                setInitialData(firstParameter);
                setShowAddButton(false);
            } else {
                setShowAddButton(true);
            }
        } catch (error) {
            toast.error('Erreur lors de la récupération des paramètres.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setShowAddButton(true);
        setInitialData(null);
    };

    return (
        <div>
            {showAddButton ? (
                <div className="text-center mt-35" style={{ minHeight: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {isLoading ? (
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    ) : (
                        <>

                            <div style={{textAlign: 'center', padding: '20px'}}>
                                <img src="assets/images/setting/no_data.png" alt="Aucun transfert"
                                     style={{width: '100px', marginBottom: '20px'}}/>
                                <p style={{color: '#666', fontSize: '1.2em'}}>Aucun paramètre disponible</p>
                                <Button variant="primary" onClick={() => setShowAddButton(false)}>
                                    Ajouter
                                </Button>
                            </div>

                        </>
                    )}
                    <style>
                        {` @keyframes spin {from {transform: rotate(0deg);}to {transform: rotate(360deg);}}`}
                    </style>
                </div>
            ) : (
                initialData ? (
                    <EditForm userName={userName} initialData={initialData} onCancel={handleCancel} onDataReload={fetchParameters} />
                ) : (
                    <CreateForm userName={userName} onCancel={handleCancel} onDataReload={fetchParameters} />
                )
            )}

        </div>
    );
};

export default DynamicForm;